import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the Chrome Extension Promo Tile Generator tool
 */
export const chromeExtensionPromoTileGeneratorFAQ: FAQItem[] = [
  {
    question: "What are Chrome Web Store promo tiles?",
    answer:
      "The Chrome Web Store requires 3 promotional tile images at specific dimensions for listings: Small tile (440 x 280), Large tile (920 x 680), and Marquee (1400 x 560). These appear in the store's featured sections and in search results. Different from screenshots (640 x 400 or 1280 x 800) and from your extension icon (128 x 128).",
  },
  {
    question: "What size should my source image be?",
    answer:
      "Upload at least 1400 x 560 pixels (the largest output size) — this prevents upscaling artifacts. 1920 x 1080 or higher is even better. The tool downscales but never upscales, so the source quality determines the output quality. If your source is smaller than 1400 wide, the marquee output will be visibly blurry.",
  },
  {
    question: "What if my source image has the wrong aspect ratio?",
    answer:
      "The 3 tiles have different aspect ratios: Small (1.57:1), Large (1.35:1), Marquee (2.5:1). The tool fits your image into each target, centering and cropping to match the aspect ratio. If your source is 16:9 (1.78:1), the small and large tiles get center-cropped slightly; the marquee gets letterboxed (or you can pre-crop your source to match each target).",
  },
  {
    question: "Does the tool upload my image anywhere?",
    answer:
      "No. All processing happens in your browser using JavaScript and HTML5 canvas. Your image never leaves your device — we don't upload, store, or access your files. The ZIP file is also generated locally. This matters for in-development extension branding you don't want to share publicly yet.",
  },
  {
    question: "How do I upload these to the Chrome Web Store?",
    answer:
      "After downloading the ZIP, extract the 3 PNG files. In your Chrome Web Store Developer Dashboard, go to your extension → Store Listing → Promotional Images. Upload each tile to its corresponding size slot (Small 440x280, Large 920x680, Marquee 1400x560). The Marquee is optional but recommended — extensions WITH a marquee get more visibility in featured sections.",
  },
  {
    question: "Do I need all 3 tile sizes?",
    answer:
      "The Small tile (440 x 280) is REQUIRED for store listing. Large and Marquee are optional but strongly recommended — extensions without them get less visibility in the Web Store's featured carousels and search results. The marquee in particular is featured by the Web Store team for promotion campaigns. Generating all 3 takes no extra effort with this tool.",
  },
  {
    question: "Should the tile match my extension's icon?",
    answer:
      "The tile should be RECOGNIZABLY connected to your icon but doesn't need to be identical. Most successful Web Store listings use a wider scene (showing the extension in context, or featuring a screenshot snippet, or a hero illustration) rather than just a giant version of the icon. The icon goes in a small corner of the tile; the rest sells what the extension does. Browse top-rated extensions in your category for layout inspiration.",
  },
  {
    question: "Do I need to pay to use this tool?",
    answer:
      "No. The Chrome Extension Promo Tile Generator is 100% free with no signup, no watermarks, no premium tier. PlugMonkey offers free tools because we're a Chrome extension company — we want more extensions to ship, and tools that lower the friction help the whole ecosystem.",
  },
];
